
import { ALLOWED_LOCKER_SURVEY_BOOKING_STATUSES, ROUTES } from '@/constants'
import mustache from 'mustache'

import { SET_IS_LOADING_APP } from '@/store/mutation-types'
import { bookingMixin } from '@/mixins'
import foFooter from '@/components/footer/footer.vue'
import foHeader from '@/components/header/header.vue'
import mixins from 'vue-typed-mixins'

export default mixins(bookingMixin).extend({
  name: 'locker-survey-confirmation',
  components: { foHeader, foFooter },
  data: () => ({
    hasLoaded: false,
  }),
  computed: {
    parsedContent(): string | undefined {
      if (this.clientPage?.config.customContent?.body) {
        return mustache.render(
          this.clientPage!.config.customContent?.body
            .replace(/<p>(.*?)<\/p>/gm, '$1')
            .replace(/&lt;/gm, '<')
            .replace(/&gt;/gm, '>')
            .replace(/&amp;/gm, '&')
            .replace(/&nbsp;/gm, ' ')
            .replace(/<br>/gm, ''),
        {},
        )
      }
    },
  },
  async beforeMount() {
    const {
      query: { language },
    } = this.$route

    this.language = language?.toString() || ''
    await this.getBooking(this.$route.name!, this.language)


    if (!this.clientPage || !this.booking || !ALLOWED_LOCKER_SURVEY_BOOKING_STATUSES.includes(this.booking.status) ) {
      return this.$router.push({ name: ROUTES.NOT_FOUND })
    }

    this.hasLoaded = true
  },
  mounted() {
    this.$store.commit(SET_IS_LOADING_APP, false)
  },
})
